export default function marquee() {
    if(document.querySelector(".marquee")) {
        $(".marquee").marquee({
            duration: 10000,
            delayBeforeStart: 0,
            direction: "left",
            duplicated: false,
        });
    }
}

